import { Text } from '@chakra-ui/react';

export const Messages = () => (
  <Text textStyle="h3" as="h3">
    Messages
  </Text>
);
